










































































import TitleAndMessage from '@/components/TitleAndMessage.vue'
import KInput from '@/lib/keep-ui/KInput.vue'
import {forEach} from 'lodash'
import Translation from '@/mixins/Translation'
import {isMobilePhone} from 'validator'
import {Component, Mixins, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {Form, FormItem} from 'element-ui'

const auth = namespace('auth')
const layout = namespace('layout')

interface Errors {
  phone: boolean
  certificateNumber: boolean
}

const TIME_LIMIT = 180
const TIMEOUT = 1000

/**
 * @displayName sign-up/UserPage
 */
@Component({
  components: {
    TitleAndMessage,
    KInput,
    [FormItem.name]: FormItem,
    [Form.name]: Form,
  },
})
export default class UserPage extends Mixins(Translation) {
  errors: Errors = {
    phone: true,
    certificateNumber: true,
  }

  phone = null
  certificateNumber = ''

  requestStatus = 'pending'
  certificateStatus = 'pending'
  requestLoading: boolean = false
  certificateLoading: boolean = false

  certifyTimeLimit = 0
  timer = null as any

  @auth.Action('requestPhoneCode') requestPhoneCode
  @auth.Action('resisterPhone') resisterPhone
  @auth.Action('registerUser') registerUser
  @auth.Action('getUser') getUser
  @layout.Mutation('updateError') updateError

  get timerCount() {
    const min = Math.floor((this.certifyTimeLimit % 3600) / 60)
    const sec = this.certifyTimeLimit % 60
    const minText = this.tc('min', min, {'min': min})
    const secText = this.tc('sec', sec, {'sec': sec})
    return `${minText} ${secText}`
  }

  get requestError() {
    if(this.requestStatus === 'forbidden') {
      return this.ts('verification.request-limit')
    }
    return ''
  }

  get phoneCodeError() {
    return this.certificateError || this.timeOverError
  }

  get certificateError() {
    if(this.certificateStatus === 'failed') {
      return this.ts('verification.certificate-failed')
    }
    return ''
  }

  get timeOverError() {
    if(this.certifyTimeLimit <= 0) {
      return this.ts('verification.time-over')
    }
    return ''
  }

  get rules() {
    const {ts} = this
    return {
      phone: [
        {
          required: true,
          type: 'string',
          message: ts('verification.required.phone-number'),
          trigger: 'change',
        },
        {
          validator: (_, value, callback) => {
            let callbackResult = undefined as any
            if(!isMobilePhone(value, 'ko-KR')) {
              callbackResult = new Error(ts('verification.format.phone-number') as any)
            }
            return callback(callbackResult)
          },
          trigger: 'change',
        },
        {
          validator: (_, __, callback) => {
            let callbackResult = undefined as any
            if(this.requestError) {
              callbackResult = new Error(this.requestError as any)
            }
            return callback(callbackResult)
          },
          trigger: ['blur', 'change'],
        },
      ],
      certificateNumber: [
        {
          required: true,
          type: 'string',
          message: ts('verification.required.certificate-number'),
          trigger: 'change',
        },
        {
          validator: (_, __, callback) => {
            let callbackResult = undefined as any
            if(this.timeOverError) {
              callbackResult = new Error(this.timeOverError as any)
            }
            return callback(callbackResult)
          },
          trigger: ['blur', 'change'],
        },
      ],
    }
  }

  get isFormError(): boolean {
    const errors = {...this.errors}
    let error = false
    forEach(errors, (value) => {
      if(value) {
        error = true
        return false
      }
    })
    return error
  }

  @Watch('requestStatus')
  __requestStatus(value) {
    if(value === 'success') {
      this.startCount()
    } else {
      this.stopCount()
    }
  }

  mounted() {
    this.getUser()
  }

  stopCount() {
    clearInterval(this.timer)
  }

  startCount() {
    this.setCertifyTimeLimit()
    this.timer = setInterval(() => {
      this.decrementCertifyTimeLimit()
      if(this.certifyTimeLimit <= 0) {
        this.stopCount()
      }
    }, TIMEOUT)
  }

  setCertifyTimeLimit(time = TIME_LIMIT) {
    this.certifyTimeLimit = time
  }

  decrementCertifyTimeLimit() {
    this.certifyTimeLimit -= 1
  }

  onValidate(field, value) {
    this.errors[field] = !value
    this.errors = {...this.errors}
  }

  onRequestPhoneCode() {
    if(this.errors.phone || this.requestLoading) {
      return
    }
    const form = this.$refs.form as any
    form.validateField('phone')
    this.requestLoading = true

    this.requestStatus = 'pending'
    this.requestPhoneCode({phone: this.phone})
      .then(() => {
        this.requestStatus = 'success'
        this.requestLoading = false
        this.certificateNumber = ''
        this.certificateStatus = 'pending'
      })
      .catch((error) => {
        const {status} = error.response
        this.requestStatus = status === 403 ? 'forbidden' : 'failed'
        this.requestLoading = false
        this.updateError({
          id: 'request-code',
          message: this.ts('error.request'),
        })
        throw error
      })
  }

  async onRegisterPhone() {
    const form = this.$refs.form as any
    const valid = await form.validate()

    if(valid) {
      this.certificateStatus = 'pending'
      this.certificateLoading = true
      this.resisterPhone({
        phone: this.phone,
        phoneCode: this.certificateNumber,
      })
        .then(() => {
          this.certificateStatus = 'success'
          this.certificateLoading = false
          this.stopCount()
          this.$router
            .replace({name: 'home'})
            .catch((err) => err)
        })
        .catch((error) => {
          this.certificateStatus = 'failed'
          this.certificateLoading = false
          this.updateError({
            id: 'certificate-code',
            message: this.ts('error.certificate'),
          })
          throw error
        })
    }
  }
}
